export function validateRegistrationNumber (taxRegistrationNumber) {
  const multipliers = [8, 7, 6, 5, 4, 3, 2]
  let total = 0

  // We are only handling 9 digit numbers
  if (taxRegistrationNumber.length !== 9) {
    return false
  }

  // 0 taxRegistrationNumber numbers disallowed!
  if (Number(taxRegistrationNumber.slice(0)) === 0) {
    return false
  }

  // Check range is OK for modulus 97 calculation
  const no = Number(taxRegistrationNumber.slice(0, 7))

  // Extract the next digit and multiply by the counter.
  for (let i = 0; i < 7; i++) {
    total += Number(taxRegistrationNumber.charAt(i)) * multipliers[i]
  }

  // Old numbers use a simple 97 modulus, but new numbers use an adaptation of that (less 55).
  // Our taxRegistrationNumber number could use either system, so we check it against both.
  // Establish check digits by subtracting 97 from total until negative.
  let checkDigit = total
  while (checkDigit > 0) {
    checkDigit = checkDigit - 97
  }

  // Get the absolute value and compare it with the last two characters of the taxRegistrationNumber number.
  // If the same, then it is a valid traditional check digit i.e. Modulus 97.
  checkDigit = Math.abs(checkDigit)
  if (checkDigit === Number(taxRegistrationNumber.slice(7, 9))) {
    return true
  }

  // Now try the new method by subtracting 55 from the check digit if we can - else add 42
  // This checks for Modulus 97-55
  if (checkDigit >= 55) {
    checkDigit = checkDigit - 55
  } else {
    checkDigit = checkDigit + 42
  }

  const expect = Number(taxRegistrationNumber.slice(7, 9))

  return Boolean(checkDigit === expect && no > 1000000)
}
